import type {
  Customer,
  CustomerApi,
  CustomerFilters,
  CustomerFiltersUpdateApi,
  Customers,
  CustomersApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizeCustomer = (customer: CustomerApi): Customer => ({
  ...customer,
  id: customer.id,
  label: customer.name,
});

export const normalizeCustomers = (response: CustomersApi): Customers => {
  const list = (response.items ?? []).sort((a, b) => a.name.localeCompare(b.name)).map(normalizeCustomer);
  return {
    list,
    map: list.reduce(
      (acc, customer) => {
        acc[String(customer.id)] = customer;
        return acc;
      },
      {} as Customers['map'],
    ),
  };
};

export const normalizeCustomerFilters = (filters: Partial<CustomerFilters>): CustomerFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
  };
};
